import { ticketService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    signatureStatus: 'loading',
    categories: [],
    ticket: {},
    signature: {}

}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, ticket) {
        state.status       = 'success'
        state.ticket       = ticket
    },
    successSubmitComment(state, comment) {
        state.status       = 'success'
        state.ticket.comments.push(comment)
    },
    successCategories(state, categories) {
        state.status = 'success'
        state.categories = categories
    },
    fail(state) {
        state.status       = 'fail'
    },
    successSignature(state, signature) {
        state.signatureStatus = 'success'
        state.signature = signature
    }

}

const getters = {
    status: ({status}) => status,
    categories: ({categories}) => categories,
    ticket: ({ticket}) => ticket,
    signature: ({signature}) => signature,
    signatureStatus: ({signatureStatus}) => signatureStatus
}

const actions = {
    fetchCategories({commit}) {
        commit('loading')
        return ticketService.categories().then(response => {
            commit('successCategories', response.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')
        return ticketService.find(hashid).then(response => {
            commit('success', response.data.data)
        })
    },
    submitComment({commit}, data) {
        commit('loading')
        return ticketService.submitComment(data).then(response => {
            commit('successSubmitComment', response.data.data)
        })
    },
    deleteComment({commit}, hashid) {
        commit('loading')
        return ticketService.delete(hashid)

    },
    updateComment({commit}, data) {
        commit('loading')
        return ticketService.updateComment(data)
    },
    fetchSignature({commit}) {
        return ticketService.fetchSignature().then(response => {
            commit("successSignature", response.data.data)
        })
    },

}
export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}